import './App.scss';
import React, { useState, useEffect } from 'react';
import { Layout, Form, message } from 'antd';

import { ReactComponent as Nino } from './assets/images/nino.svg';
import { ReactComponent as Close } from './assets/images/close.svg';
import { ReactComponent as Logo } from './assets/images/logo.svg';

import Geocode from './components/Geocode/Geocode';
import CmpsDate from './components/CmpsDate/CmpsDate';
import CmpsFilial from './components/CmpsFilial/CmpsFilial';
import CmpsTime from './components/CmpsTime/CmpsTime';
import CmpsFc from './components/CmpsFc/CmpsFc';
import CmpsName from './components/CmpsName/CmpsName';
import CmpsSurname from './components/CmpsSurname/CmpsSurname';
import CmpsMail from './components/CmpsMail/CmpsMail';
import CmpsPhone from './components/CmpsPhone/CmpsPhone';
import CmpsCap from './components/CmpsCap/CmpsCap';
import CmpsJob from './components/CmpsJob/CmpsJob';
import CmpsConsentFirst from './components/CmpsConsentFirst/CmpsConsentFirst';
import CmpsConsentSecond from './components/CmpsConsentSecond/CmpsConsentSecond';
import CmpsConsentThird from './components/CmpsConsentThird/CmpsConsentThird';
import CmpsConsentFourth from './components/CmpsConsentFourth/CmpsConsentFourth';
import CmpsRegisteredUser from './components/CmpsRegisteredUser/CmpsRegisteredUser';
import CmpsGetAppointment from './components/CmpsGetAppointment/CmpsGetAppointment';
import CmpsModifyAppointment from './components/CmpsModifyAppointment/CmpsModifyAppointment';

import * as Api from './services/api';
import * as Utils from './services/utils';
import { Context } from './ChatContext';

const { Header, Content } = Layout;

function App() {

  const [form] = Form.useForm()
  const [withInput, setWithInput] = useState(false);
  const [context, setContext] = useState({
    coordinates: { lat: null, lon: null },
    user: null
  });

  // Steps
  const [step1, setStep1] = useState(false); // Geolocalizzazione -- Chiamata Api Google
  const [step2, setStep2] = useState(false); // Data Appuntamento -- Chiamata Api Compass
  const [step3, setStep3] = useState(false); // Filiale Appuntamento -- Chiamata Api Compass
  const [step4, setStep4] = useState(false); // Ora Appuntamento -- Chiamata Api Compass
  const [step5, setStep5] = useState(false); // Codice Fiscale -- Chiamata Api Compass
  const [step6, setStep6] = useState(false); // Inserimento Nome
  const [step7, setStep7] = useState(false); // Inserimento Cognome
  const [step8, setStep8] = useState(false); // Inserimento Email
  const [step9, setStep9] = useState(false); // Inserimento Telefono
  const [step10, setStep10] = useState(false); // Inserimento CAP
  const [step11, setStep11] = useState(false); // Inserimento Tipo Lavoro
  const [step12, setStep12] = useState(false); // Accettazione Consenso 1
  const [step13, setStep13] = useState(false); // Accettazione Consenso 2
  const [step14, setStep14] = useState(false); // Accettazione Consenso 3
  const [step15, setStep15] = useState(false); // Accettazione Consenso 4
  const [step16, setStep16] = useState(false); // Utente Censito
  const [step17, setStep17] = useState(false); // Fissa Appuntamento -- Chiamata Api Compass
  const [step18, setStep18] = useState(false); // Modifica Appuntamento -- Chiamata Api Compass

  const errorApi = () => {
    message.error("Hoops! c'è stato un errore, non è possibile continuare. A breve la chat verrà ricaricata e potrai richiedere un nuovo appuntamento.", 60, resetChat);
  };

  const onFinish = (values) => {
    if (form.getFieldValue("filiale") !== undefined) {

      let sendParams = {
        prodotto: '1',
        Consolidamento: '0',
        ...(form.getFieldValue("filiale").citta && { luogo: form.getFieldValue("filiale").citta }),
        ...(form.getFieldValue("filiale").coordinate.lat && { latitudine: form.getFieldValue("filiale").coordinate.lat }),
        ...(form.getFieldValue("filiale").coordinate.lng && { longitudine: form.getFieldValue("filiale").coordinate.lng }),
        ...(form.getFieldValue("data").easyDate && { data_appuntamento: form.getFieldValue("data").easyDate }),
        ...(form.getFieldValue("ora").label && { orario_appuntamento: form.getFieldValue("ora").label }),
        ...(form.getFieldValue("filiale").idFiliale && { id_filiale: form.getFieldValue("filiale").idFiliale }),
        ...(form.getFieldValue("filiale").nomeFiliale && { nome_filiale: form.getFieldValue("filiale").nomeFiliale }),
        ...(form.getFieldValue("tipo_impiegato") && { impiego: form.getFieldValue("tipo_impiegato").value }),
        ...(form.getFieldValue("primo_consenso") && { informativa: form.getFieldValue("primo_consenso").value }),
        ...(form.getFieldValue("secondo_consenso") && { dati_personali: form.getFieldValue("secondo_consenso").value }),
        ...(form.getFieldValue("terzo_consenso") && { societa_terze: form.getFieldValue("terzo_consenso").value })
      }

      // Parametri da passare per il recupero del token
      var user_name = null;
      var user_lanstname = null;
      var user_cf = null;
      var user_email = null;
      var user_phone = null;
      var user_cap = null;

      if (form.getFieldValue("nome") !== undefined) {
        user_name = form.getFieldValue("nome")
      } else {
        user_name = context.user?.nome ? context.user.nome : null
      }
      if (form.getFieldValue("cognome") !== undefined) {
        user_lanstname = form.getFieldValue("cognome")
      } else {
        user_lanstname = context.user?.cognome ? context.user.cognome : null
      }
      if (form.getFieldValue("cf") !== undefined) {
        user_cf = form.getFieldValue("cf")
      } else {
        user_cf = context.user?.codice_fiscale ? context.user.codice_fiscale : null
      }
      if (form.getFieldValue("email") !== undefined) {
        user_email = form.getFieldValue("email")
      } else {
        user_email = context.user?.email ? context.user.email : null
      }
      if (form.getFieldValue("telefono") !== undefined) {
        user_phone = form.getFieldValue("telefono")
      } else {
        user_phone = context.user?.telefono ? context.user.telefono : null
      }
      if (form.getFieldValue("cap") !== undefined) {
        user_cap = form.getFieldValue("cap")
      } else {
        user_cap = context.user?.cap ? context.user.cap : null
      }

      // const getRedirectUrl = (add_params) => {
      //   const currentUrl = new URL(window.location.href);
      //   let newParams = '';
      //   if(Array.from(currentUrl.searchParams.entries()).length > 0) {
      //     newParams = new URLSearchParams([
      //       ...Array.from(currentUrl.searchParams.entries()),
      //       ...Object.entries(add_params)
      //     ]).toString();
      //   } else {
      //     newParams = new URLSearchParams([
      //       ...Object.entries(add_params)
      //     ]).toString();
      //   }
      //   return `${process.env.REACT_APP_SEND_DATA_API_PATH}?${newParams}`
      // }

      const getRedirectUrl = ({ token, add_params }) => {
        console.log("In the Redirecting Process")
        // @tmp test hardcoded url (I don't know why it's not reading the env variable)
        //const redirectUrl = `https://compass-col.int.compassonline.it/fa3/?token=${token}&isB2BChat=true`;
        const currentUrl = new URL(window.location.href);
        let newParams = '';
        if (Array.from(currentUrl.searchParams.entries()).length > 0) {
          newParams = new URLSearchParams([
            ...Array.from(currentUrl.searchParams.entries()),
            ...Object.entries(add_params)
          ]).toString();
        } else {
          newParams = new URLSearchParams([
            ...Object.entries(add_params)
          ]).toString();
        }
        //const redirectUrl = `${process.env.REACT_APP_REDIRECT_FA_ENV}/fa3/?token=${token}&isB2BChat=${isB2BChat}&${newParams}`;
        // @coll
        //  const redirectUrl = `https://compass-col.int.compassonline.it/fa3/?token=${token}&isB2BChat=true&sic=true&${newParams}`;
        // @prod
        const redirectUrl = `https://compass.it/fa3/?token=${token}&isB2BChat=true&sic=true&${newParams}`;

        return redirectUrl;
      };

      Api.getToken({
        prodotto: 1,
        nome: user_name,
        cognome: user_lanstname,
        comuneNascita: null,
        provinciaNascita: null,
        dataNascita: null,
        nazioneNascita: null,
        codiceFiscale: user_cf,
        prodottoCRM: null,
        sesso: null,
        email: user_email,
        telefonoFisso: null,
        telefonoCell: user_phone,
        telefono: user_phone,
        cap: user_cap,
        exception: null,
        urlRitorno: null,
      }).then(function (response) {
        sendParams = {
          ...sendParams,
          ...(response.data.token && { token: response.data.token })
        }
        console.log(response.data)
        window.location.href = getRedirectUrl({
          token: response.data.token,
          add_params: sendParams
        });
      })
        .catch(function (error) {
          console.log(error);
          errorApi();
        });


    }
  };

  const resetChat = () => {
    nextStep('reset');
  }

  const onClose = () => {
    window.location.href = '/fa3';
  }

  const alertGeo = () => {
    const config = {
      content: "Hoops! riprova con la tua posizione attuale o fai una ricerca dell'indirizzo.",
      duration: 10,
      key: 'alert_geoloc',
      onClick: () => { message.destroy('alert_geoloc') }
    }
    message.warning(config);
  }
  const alertAutoComplete = () => {
    const config = {
      content: "Per proseguire, digita l'indirizzo e selezionalo dalla lista.",
      duration: 5,
      key: 'alert_autoc',
      onClick: () => { message.destroy('alert_autoc') }
    }
    message.warning(config);
  }

  const setMarginBottom = (status) => {
    setWithInput(status);
  }

  const nextStep = (step) => {
    switch (step) {
      case 'step1':
        setStep1(true);
        break;
      case 'step2':
        setStep2(true);
        break;
      case 'step3':
        setStep3(true);
        break;
      case 'step4':
        setStep4(true);
        break;
      case 'step5':
        setStep5(true);
        break;
      case 'step6':
        setStep6(true);
        break;
      case 'step7':
        setStep7(true);
        break;
      case 'step8':
        setStep8(true);
        break;
      case 'step9':
        setStep9(true);
        break;
      case 'step10':
        setStep10(true);
        break;
      case 'step11':
        setStep11(true);
        break;
      case 'step12':
        setStep12(true);
        break;
      case 'step13':
        setStep13(true);
        break;
      case 'step14':
        setStep14(true);
        break;
      case 'step15':
        setStep15(true);
        break;
      case 'step16':
        setStep16(true);
        break;
      case 'step17':
        setStep17(true);
        break;
      case 'step18':
        setStep18(true);
        break;
      case 'reset':
        setStep1(false);
        setStep2(false);
        setStep3(false);
        setStep4(false);
        setStep5(false);
        setStep6(false);
        setStep7(false);
        setStep8(false);
        setStep9(false);
        setStep10(false);
        setStep11(false);
        setStep12(false);
        setStep13(false);
        setStep14(false);
        setStep15(false);
        setStep16(false);
        setStep17(false);
        setStep18(false);
        setTimeout(() => {
          nextStep('step1');
        });
        break;
      default:
        break;
    }
  }

  const scrollTop = () => {
    Utils.scrollToTop();
  }

  useEffect(() => {
    Utils.eventsDataLayer('chatbot_cta', 'Chatta con me');
    nextStep('step1');
  }, []);

  return (
    <Context.Provider value={[context, setContext]}>
      <div className="App">

        <Layout className="cmps-layout">
          <Header className="cmps_header">
            <div className="cmps_header__top">
              <Logo />
              <Close className="cmps_header__top__close icon-cmps-close" onClick={onClose} />
            </div>
            <div className="cmps_header__bottom">
              <Nino className="cmps_header__bottom__avatar" />
              <div className="cmps_header__bottom__info">
                <p className="cmps_header__bottom__info__nickname">Nino il portinaio</p>
                <p className="cmps_header__bottom__info__status">Online</p>
              </div>
            </div>
          </Header>
          <Content id="cmps_content" className={`cmps_content ${withInput ? 'with-input' : ''}`} >
            <Form name="basic" onFinish={onFinish} form={form}>
              {step1 && <Geocode form={form} onComplete={nextStep} onScroll={scrollTop} onShowInput={setMarginBottom} onAlert={alertGeo} onAlertAutoComplete={alertAutoComplete} />}
              {step2 && <CmpsDate form={form} onComplete={nextStep} onScroll={scrollTop} onError={errorApi} onShowInput={setMarginBottom} onReset={resetChat} />}
              {step3 && <CmpsFilial form={form} onComplete={nextStep} onScroll={scrollTop} onError={errorApi} onShowInput={setMarginBottom} onReset={resetChat} />}
              {step4 && <CmpsTime form={form} onComplete={nextStep} onScroll={scrollTop} onError={errorApi} onShowInput={setMarginBottom} onReset={resetChat} />}
              {step5 && <CmpsFc form={form} onComplete={nextStep} onScroll={scrollTop} onError={errorApi} onShowInput={setMarginBottom} />}
              {step16 && <CmpsRegisteredUser form={form} onComplete={nextStep} onScroll={scrollTop} onShowInput={setMarginBottom} />}
              {step6 && <CmpsName form={form} onComplete={nextStep} onScroll={scrollTop} onShowInput={setMarginBottom} />}
              {step7 && <CmpsSurname form={form} onComplete={nextStep} onScroll={scrollTop} onShowInput={setMarginBottom} />}
              {step8 && <CmpsMail form={form} onComplete={nextStep} onScroll={scrollTop} onShowInput={setMarginBottom} />}
              {step9 && <CmpsPhone form={form} onComplete={nextStep} onScroll={scrollTop} onShowInput={setMarginBottom} />}
              {step10 && <CmpsCap form={form} onComplete={nextStep} onScroll={scrollTop} onShowInput={setMarginBottom} />}
              {step11 && <CmpsJob form={form} onComplete={nextStep} onScroll={scrollTop} onShowInput={setMarginBottom} />}
              {step12 && <CmpsConsentFirst form={form} onComplete={nextStep} onScroll={scrollTop} onShowInput={setMarginBottom} />}
              {step13 && <CmpsConsentSecond form={form} onComplete={nextStep} onScroll={scrollTop} onShowInput={setMarginBottom} />}
              {step14 && <CmpsConsentThird form={form} onComplete={nextStep} onScroll={scrollTop} onShowInput={setMarginBottom} />}
              {step15 && <CmpsConsentFourth form={form} onComplete={nextStep} onScroll={scrollTop} onShowInput={setMarginBottom} />}
              {step17 && <CmpsGetAppointment form={form} onScroll={scrollTop} onShowInput={setMarginBottom} />}
              {step18 && <CmpsModifyAppointment form={form} onScroll={scrollTop} onShowInput={setMarginBottom} />}
            </Form>
          </Content>
        </Layout>
      </div>
    </Context.Provider>
  );
}

export default App;
